import { useEffect, useRef } from "react";
import { motion } from "framer-motion";

const DialogBox = ({ isOpen, onClose, title, message,onConfirm }) => {
  const dialogRef = useRef(null);
  const previousFocus = useRef(null);


  const handleClose = () => {
    onClose();
  };

  return (
    isOpen && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <motion.div
          ref={dialogRef}
          tabIndex="-1"
          className="bg-white rounded-lg shadow-lg p-6 w-96"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          onKeyDown={(e) => e.key === "Escape" && handleClose()} // Close on ESC
        >
          {/* Title */}
          <h2 className="text-lg font-semibold text-gray-800">{title}</h2>

          {/* Message */}
          <p className="text-gray-600 mt-2">{message}</p>

          {/* Buttons */}
          <div className="mt-4 flex justify-end space-x-2">

        <button
        onClick={onClose}
        className={`px-4 py-2 text-sm font-medium rounded-md bg-gray-300 text-gray-700`}
        >
Cancel
        </button>
        <button
        onClick={onConfirm}
        className={`px-4 py-2 text-sm font-medium rounded-md bg-red-600 text-white`}
        >
Delete
        </button>

          
          </div>
        </motion.div>
      </div>
    )
  );
};

export default DialogBox;
